import { createAction, createAsyncAction } from 'typesafe-actions';

export const authenticate = createAction('@AUTH/SIGNED')<boolean>();

export const generateToken = createAsyncAction(
  '@AUTH/GENERATE_TOKEN_REQUEST',
  '@AUTH/GENERATE_TOKEN_SUCCESS',
  '@AUTH/GENERATE_TOKEN_FAILURE'
)<undefined, string, string>();

export const validateToken = createAsyncAction(
  '@AUTH/VALIDATE_TOKEN_REQUEST',
  '@AUTH/VALIDATE_TOKEN_SUCCESS',
  '@AUTH/VALIDATE_TOKEN_FAILURE'
)<string, ValidationResponseDto, string>();

export const getUserConfirmedData = createAsyncAction(
  '@GET_CONFIRMED_DATA/REQUEST',
  '@GET_CONFIRMED_DATA/SUCCESS',
  '@GET_CONFIRMED_DATA/FAILURE'
)<undefined, GQL.IUserResponse, string>();

export const setUserConfirmedData = createAsyncAction(
  '@SET_CONFIRMED_DATA/REQUEST',
  '@SET_CONFIRMED_DATA/SUCCESS',
  '@SET_CONFIRMED_DATA/FAILURE'
)<{ data: GQL.IUserInput }, string, string>();

export const setEmailConfirmado = createAsyncAction(
  '@SET_EMAIL_CONFIRMADO/REQUEST',
  '@SET_EMAIL_CONFIRMADO/SUCCESS',
  '@SET_EMAIL_CONFIRMADO/FAILURE'
)<{ data: GQL.ISetEmailConfirmado }, string, string>();

export const setTelefoneConfirmado = createAsyncAction(
  '@SET_TELEFONE_CONFIRMADO/REQUEST',
  '@SET_TELEFONE_CONFIRMADO/SUCCESS',
  '@SET_TELEFONE_CONFIRMADO/FAILURE'
)<{ data: GQL.ISetTelefoneConfirmado }, string, string>();

export const setEnderecoConfirmado = createAsyncAction(
  '@SET_ENDERECO_CONFIRMADO/REQUEST',
  '@SET_ENDERECO_CONFIRMADO/SUCCESS',
  '@SET_ENDERECO_CONFIRMADO/FAILURE'
)<{ data: GQL.ISetEnderecoConfirmado }, string, string>();

export const generateNewTelephone = createAsyncAction(
  '@GENERATE_TELEPHONE/REQUEST',
  '@GENERATE_TELEPHONE/SUCCESS',
  '@GENERATE_TELEPHONE/FAILURE'
)<GenerateTokenToNewTelephone, boolean, boolean>();

export const validateNewTelephone = createAsyncAction(
  '@VALIDATE_TELEPHONE/REQUEST',
  '@VALIDATE_TELEPHONE/SUCCESS',
  '@VALIDATE_TELEPHONE/FAILURE'
)<ValidateNewTelephone, boolean, boolean>();

export const setCPF = createAction('@SET/CPF')<string>();
export const setAcceptedTerms = createAction('@SET/ACCEPTED_TERMS')<boolean>();
export const rehydrate = createAction('persist/REHYDRATE')<ApplicationState>();
export const updatePercentage = createAction('persist/PERCENTAGE')<number>();
export const purge = createAction('persist/PURGE')();
export const cleanTelephoneCredential = createAction('persist/CLEAN')();
export const page = createAction('@SET/PAGE')<string>();
export const tokenSentTimeAction = createAction('@SET/TOKENSENTTIME')<Date>();
